import * as React from 'react';
import S from './LottieAnimation.styles';
const LottieAnimation = ({ src, autoplay = true, direction = 'forward', loop = true, mode = 'normal', speed = 1, }) => {
    React.useEffect(() => {
        import(/* webpackChunkName: "lottie-player" */ '@lottiefiles/lottie-player');
    }, []);
    return (React.createElement(S.Container, null,
        React.createElement("lottie-player", { autoplay: autoplay, direction: direction, loop: loop, mode: mode, speed: speed, src: src })));
};
export default LottieAnimation;
